var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.handleData)?_c('div',[_c('h5',[_vm._v("  New : "),_c('b',[_vm._v(_vm._s(_vm.handleData.invoiceId)+" - "+_vm._s(_vm.handleData.serial_no))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }